import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../lib/api';
import { useT } from '../lib/i18n';
import { Button } from './ui';

/** "Agenda in je telefoon": subscribe to one person's appointments in Google, Apple or Outlook. */
export function CalendarFeed({ orgId, staffMemberId, own }: { orgId: string; staffMemberId: string; own: boolean }) {
  const t = useT();
  const qc = useQueryClient();
  const key = ['feed', orgId, staffMemberId];
  const feed = useQuery({ queryKey: key, queryFn: () => api<{ url: string }>(`/orgs/${orgId}/team/${staffMemberId}/feed`).then((r) => r.url) });
  const renew = useMutation({
    mutationFn: () => api<{ url: string }>(`/orgs/${orgId}/team/${staffMemberId}/feed/renew`, { method: 'POST' }).then((r) => r.url),
    onSuccess: (url) => qc.setQueryData(key, url),
  });
  const [copied, setCopied] = useState(false);
  if (!feed.data) return null;
  const webcal = feed.data.replace(/^https?:/, 'webcal:');
  const google = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcal)}`;

  return (
    <section className="flex flex-col gap-3 border-t border-line pt-5">
      <div>
        <h3 className="font-semibold">{own ? t('feed.titleOwn') : t('feed.title')}</h3>
        <p className="text-sm text-muted">{t('feed.intro')}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <a href={webcal} className="inline-flex min-h-11 items-center rounded-full border border-line bg-surface px-4 text-[15px] font-semibold hover:bg-subtle">
          {t('feed.apple')}
        </a>
        <a href={google} target="_blank" rel="noreferrer" className="inline-flex min-h-11 items-center rounded-full border border-line bg-surface px-4 text-[15px] font-semibold hover:bg-subtle">
          {t('feed.google')}
        </a>
        <Button
          variant="ghost"
          onClick={async () => {
            await navigator.clipboard.writeText(feed.data!);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 2000);
          }}
        >
          {copied ? `✓ ${t('booking.copied')}` : t('feed.copy')}
        </Button>
      </div>
      <p className="text-sm text-muted">
        {t('feed.private')}{' '}
        <button type="button" className="font-semibold text-accent-strong hover:underline" onClick={() => window.confirm(t('feed.renewConfirm')) && renew.mutate()}>
          {t('feed.renew')}
        </button>
      </p>
    </section>
  );
}
